/* Copyright (c) 2026 Hyegro Pty Ltd. All rights reserved. */

/**
 * A user's name that opens their profile (/users/:id/profile), which every
 * signed-in user may view.
 *
 * v2 only: in the classic UI, or when the record holds no user id (a broker
 * agent, an imported name), it is the bare name, so shared screens render
 * exactly what they did before.
 *
 * tone="inherit" sits in a record hero's meta line beside the account and
 * contact links; tone="link" is the blue v2 link for field values.
 */

import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useTheme } from "@mui/material/styles";
import { v2 as t } from "styles/tokens/v2";

const TONES = {
  inherit: { color: "inherit", fontWeight: 600 },
  link: { color: t.link, fontWeight: 500, textDecoration: "none" },
};

export default function UserLink({ userId, name, tone }) {
  const isV2 = useTheme()?.pearlUi === "v2";
  if (!isV2 || userId === null || userId === undefined || userId === "" || !name) return name;
  return (
    <Link to={`/users/${userId}/profile`} style={TONES[tone]} onClick={(e) => e.stopPropagation()}>
      {name}
    </Link>
  );
}

UserLink.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  name: PropTypes.node,
  tone: PropTypes.oneOf(["inherit", "link"]),
};

UserLink.defaultProps = { userId: null, name: null, tone: "inherit" };
